import React from 'react';

const Impact = () => {
  // Updated stats with new numbers - NO HOVER EFFECTS
  const stats = [
    { value: "Weltweit", label: "aktiv", suffix: "" },
    { value: "8", label: "Hektar geschützt", suffix: "" },
    { value: "160", label: "Hektar in Verhandlungen", suffix: "" },
    { value: "2'000+", label: "Tierarten behalten ihr Zuhause", suffix: "" }
  ];

  return (
    <section className="impact-section no-hover-effects py-12 sm:py-16 md:py-20 bg-gradient-to-br from-[#FF1B8D] via-[#FF1B8D] to-[#E01679] text-white relative overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-white/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-[#FF9B8C]/20 rounded-full blur-3xl"></div>

      <div className="container mx-auto px-2 sm:px-4 md:px-6 lg:px-8 relative z-10">
        {/* Header */}
        <div className="text-center mb-6 sm:mb-8 md:mb-12 no-hover-effects px-2">
          <h2 className="no-hover-effects text-lg sm:text-2xl md:text-3xl lg:text-4xl xl:text-5xl font-bold mb-2 sm:mb-3 md:mb-4 text-center" style={{ fontFamily: "'Playfair Display', serif" }}>
            Unsere Wirkung in Zahlen
          </h2>
          <p className="no-hover-effects text-white/90 text-[11px] sm:text-sm md:text-base lg:text-lg xl:text-xl max-w-2xl mx-auto text-center">
            Gemeinsam haben wir bereits Grossartiges erreicht
          </p>
        </div>

        {/* Impact Grid - Always 4 cols, responsive sizing */}
        <div className="grid grid-cols-4 gap-1 sm:gap-2 md:gap-4 lg:gap-6 max-w-4xl mx-auto">
          {stats.map((stat, index) => (
            <div
              key={index}
              className="impact-stat-container group hover:transform hover:scale-105 transition-all duration-300"
            >
              <div className="impact-stat-card no-hover-effects bg-white/10 backdrop-blur-sm rounded-md sm:rounded-lg md:rounded-xl lg:rounded-2xl p-1.5 sm:p-2 md:p-4 lg:p-5 border border-white/20 group-hover:bg-white/20 transition-all duration-300 min-h-[60px] sm:min-h-[80px] md:min-h-[100px] lg:min-h-[120px] flex flex-col justify-center items-center text-center">
                <div className="impact-stat-value no-hover-effects font-bold mb-0.5 sm:mb-1 md:mb-2 leading-tight text-white text-[10px] sm:text-base md:text-xl lg:text-3xl xl:text-4xl whitespace-nowrap">
                  {stat.value}{stat.suffix}
                </div>
                <div className="impact-stat-label no-hover-effects text-white/90 text-[7px] sm:text-[9px] md:text-xs lg:text-sm font-medium leading-tight text-center">
                  {stat.label}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Impact;
